import * as React from "react";
import Team from "../commons/model/Team";
import TeamCard from "./TeamCard";
import Country from "../commons/model/address/Country";

interface TeamCardsProps {
  teams: Team[];
  onTeamSelected: (team: Team) => void;
  countries: Country[];
}

interface TeamCardsState {
  selected?: Team;
}

export default class TeamCards extends React.Component<TeamCardsProps, TeamCardsState> {
  constructor(props: TeamCardsProps) {
    super(props);
    this.state = { selected: undefined };
  }

  private onSelect(selectedTeam: Team) {
    this.setState(
      (state) => {
        if (selectedTeam == state.selected) {
          return { selected: undefined }; //unselect
        } else {
          return { selected: selectedTeam };
        }
      },
      () => this.props.onTeamSelected(this.state.selected)
    );
  }

  render() {
    return (
      <div className="team-cards h-flex container">
        {this.props.teams.map((team, index) => (
          <TeamCard
            key={team.name}
            team={team}
            selected={this.props.teams[index] == this.state.selected}
            onSelect={() => this.onSelect(this.props.teams[index])}
            countries={this.props.countries}
          />
        ))}
      </div>
    );
  }
}
